<template>
  <div class="loginBody" ref="loginBody" :style=backgroundImg>
    <div class="logoBody">
      <el-image :src="imageLogo"/>
    </div>
    <el-row type="flex" justify="center" align="middle">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <div class="dfvb">
          <img src="../../assets/images/back.png" alt="" style="width:100%;height:100%" srcset="">
        </div>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card">
          <el-tabs v-model="activeName" @tab-click="getImgCaptcha" style="padding:20px;">
            <el-tab-pane label="普通登录" name="one">
              <el-form :model="ordinaryLogin" :rules="ordinaryLoginRules" ref="ordinaryLogin" label-width="100px"
                       class="ordinaryLoginForm" label-position="top">
                <el-form-item label="" prop="loginName">
                  <el-input prefix-icon="el-icon-user" v-model="ordinaryLogin.loginName" placeholder="手机号/用户名"/>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input prefix-icon="el-icon-lock" v-model="ordinaryLogin.password" placeholder="密码"
                            :show-password="true"/>
                </el-form-item>
                <el-form-item label="" prop="imgCaptcha">
                  <el-input class="imgCaptcha" prefix-icon="el-icon-message" v-model="ordinaryLogin.captcha"
                            placeholder="请输入图形验证码">
                    <template slot="append">
                      <el-link @click="getImgCaptcha">
                        <el-image :src="imgCaptcha"/>
                      </el-link>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="" prop="ordinaryRememberMe">
                  <div class="rememberBody" ref="rememberBody">
                    <el-checkbox label="记住账号" v-model="ordinaryLogin.rememberMe"/>
                    <el-link type="primary" href="/forget/password">忘记密码</el-link>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button class="loginButton" type="primary" v-debounce @click="doOrdinaryLogin('ordinaryLogin')"
                             :loading="loginLoading">登 录
                  </el-button>
                </el-form-item>
              </el-form>
              <div class="register">
                <el-link type="primary" href="/register">注册账号</el-link>
              </div>
            </el-tab-pane>
            <el-tab-pane label="短信快捷登录" name="two">
              <el-form :model="phoneCaptchaLogin" :rules="phoneCaptchaLoginRules" ref="phoneCaptchaLogin"
                       label-width="100px" class="phoneCaptchaLoginForm" label-position="top">
                <el-form-item label="" prop="loginName">
                  <el-input prefix-icon="el-icon-mobile" v-model="phoneCaptchaLogin.loginName" placeholder="11位手机号">
                    <template slot="prepend">+86</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="" prop="imgCaptcha">
                  <el-input class="imgCaptcha" prefix-icon="el-icon-message" v-model="phoneCaptchaLogin.imgCaptcha"
                            placeholder="请输入图形验证码">
                    <template slot="append">
                      <el-link @click="getImgCaptcha">
                        <el-image :src="imgCaptcha"/>
                      </el-link>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="" prop="phoneCaptcha">
                  <el-input prefix-icon="el-icon-message" v-model="phoneCaptchaLogin.phoneCaptcha" placeholder="输入验证码">
                    <el-button slot="append" type="primary" @click="ClickNote()">获取验证码</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="" prop="ordinaryRememberMe">
                  <div class="rememberBody" ref="rememberBody">
                    <el-checkbox label="记住账号" v-model="phoneCaptchaLogin.rememberMe"/>
                    <el-link type="primary" href="/forget/password">忘记密码</el-link>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button class="loginButton" v-debounce type="primary" @click="doPhoneCaptchaLogin('phoneCaptchaLogin')"
                             :loading="loginLoading">登 录
                  </el-button>
                </el-form-item>
              </el-form>
              <div class="register">
                <el-link type="primary" href="/register">注册账号</el-link>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      backgroundImg: {
        backgroundImage: 'url(' + require('/src/assets/images/background/background-1.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      },
      imageLogo: require('/src/assets/images/logo/logo-1.png'),
      activeName: 'one',
      imgCaptcha: '',
      loginLoading: false,
      ordinaryLogin: {
        loginName: '',
        password: '',
        captcha: '',
        rememberMe: false
      },
      phoneCaptchaLogin: {
        loginName: '',
        imgCaptcha: '',
        phoneCaptcha: '',
        rememberMe: false
      },
      ordinaryLoginRules: {
        loginName: [
          {required: true, message: '请输入登录名或手机号', trigger: 'blur'},
          {min: 4, max: 18, message: '长度在 4 到 18 个字符', trigger: 'blur'},
          {validator: checkOrdinaryLoginName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 4, max: 18, message: '长度在 4 到 18 个字符', trigger: 'blur'},
          {validator: checkOrdinaryPassword, trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入图形验证码', trigger: 'blur'},
          {min: 5, max: 5, message: '长度在 5 个字符', trigger: 'blur'},
          {validator: checkImgCaptcha, trigger: 'blur'}
        ]
      },
      phoneCaptchaLoginRules: {
        loginName: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
        ],
        imgCaptcha: [
          {required: true, message: '请输入图形验证码', trigger: 'blur'},
          {min: 5, max: 5, message: '长度在 5 个字符', trigger: 'blur'},
        ],
        phoneCaptcha: [
          {required: true, message: '请输入手机验证码', trigger: 'blur'},
          {min: 5, max: 5, message: '长度在 5 个字符', trigger: 'blur'},
        ]
      },
      resc:"",
    };
    let checkOrdinaryLoginName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("用户名格式不对！"));
      } else {
        callback();
      }
    };
    let checkOrdinaryPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("密码格式不对！"));
      } else {
        callback();
      }
    };
    let checkImgCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error("图形验证码格式不对！"));
      } else {
        callback();
      }
    }
  },
  	watch: {
		resc(val) {
      if(val != null && val != undefined && val != ""){
        localStorage.setItem("resc", val)
      }
		},
	},
  methods: {
    // 获取图片验证码
    getImgCaptcha() {
      const that = this
      that.$http.get(that.$requestUrl.GET_IMG_CAPTCHA).then((res) => {
        let data = res.data;
        if (200 === data.code) {
          let image = data.data;
          that.imgCaptcha = 'data:image/png;base64,' + image;
        } else {
          that.$message.error(data.msg);
        }
      }).catch(() => {
        that.$message.error(that.$errorMessage.SEVER_ERROR);
      })
    },
    ClickNote(){
      // 短信验证码 /to/sms/send
       const that = this
       let obj = {
            "smsTo": this.phoneCaptchaLogin.loginName,
            "smsType": 1,
            "imgCaptcha":this.phoneCaptchaLogin.imgCaptcha,
          }
      that.$http.post(that.$requestUrl.GET_PHONE_CAPTCHA,obj).then((res) => {
        let data = res.data;
        if (200 === data.code) {
          // console.log(res)
        } else {
          that.$message.error(data.msg);
        }
      }).catch(() => {
        that.$message.error(that.$errorMessage.SEVER_ERROR);
      })
    },
    doOrdinaryLogin(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(this.$requestUrl.ORDINARY_LOGIN, this.ordinaryLogin).then((res) => {
            let data = res.data;
            if (200 === data.code) {
              if(data.data != "" && data.data!=null){
                localStorage.setItem("resc", data.data)
                localStorage.setItem(this.$constant.XF_AUTHORIZATION_LG, data.data)
                var cookies=document.cookie;
                var resc = ""
                    if(cookies && cookies.indexOf("; ")>= 0){
                        var arr=cookies.split('; ');
                        if(arr[0].indexOf("XF_L_T")>= 0){
                            resc = arr[0].slice(7)
                        }else if( arr[0].indexOf("XF_L_T") == -1){
                            resc = arr[1].slice(7)
                        }
                    }
                    if(resc){
                      localStorage.setItem("resc", resc)
                    }
                    this.Jurisdiction()
                    this.resc = resc
                    this.$router.push({name: 'home'})
              }
            this.getCurrentTime()
            } else {
              this.$message.error(data.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        } else {
          return false;
        }
      });
    },
    doPhoneCaptchaLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           this.$http.post(this.$requestUrl.ORDINARY_LOGIN, this.ordinaryLogin).then((res) => {
            let data = res.data;
            if (200 === data.code) {
            this.getCurrentTime()
              localStorage.setItem(this.$constant.XF_AUTHORIZATION_LG, data.data)
               var cookies=document.cookie;
               var resc = ""
              if(cookies && cookies.indexOf("; ")>= 0){
                  var arr=cookies.split('; ');
                  if(arr[0].indexOf("XF_L_T")>= 0){
                      resc = arr[0].slice(7)
                  }else if( arr[0].indexOf("XF_L_T") == -1){
                      resc = arr[1].slice(7)
                  }
              }
              if(resc){
                 this.Jurisdiction()
                localStorage.setItem("resc", resc)
                this.$router.push({name: 'home'})
              }else{
                this.$router.push({name: 'login'})
              }
            } else {
              this.$message.error(data.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        } else {
          return false;
        }
      });
    },
    getCurrentTime() {
        //获取当前时间并打印
	    	let date = new Date();
      localStorage.setItem("LoginTime",date) // 登录国标时间
      let putOfTime = localStorage.getItem("putTime")
      if(putOfTime){
        let  startTime=Date.parse(date);
        let  endTime=Date.parse(putOfTime);
          if(startTime>endTime){
          localStorage.removeItem("xf_Authorization_lg")
        }else{
        }
      }else{
         let dateT = date.getTime()
        let time = dateT+60*60*7000
        let putTime = new Date(time)
        localStorage.setItem("putTime",putTime)
      }
    },
        Jurisdiction(){
       let obj = {
              "parentId": ""
            }
         this.$http.post(this.$requestUrl.GET_USER_PERMISSION,obj).then((res) => {
            let data = res.data;
            if (200 === data.code) {
              localStorage.setItem("Authority",data.data)
            }else{
              this.$message.error(data.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
  },
  created() {

  },
  mounted() {
    this.getImgCaptcha();

    
  }
}
</script>

<style lang="scss">
.loginBody {
  height: 100%;

  .logoBody {
    position: absolute;
    left: 30px;
    top: 20px;
  }

  .el-row {
    height: 100%;

    .ordinaryLoginForm {
      .rememberBody {
        display: flex;
        justify-content: space-between;
      }

      .imgCaptcha {
        .el-input-group__append, .el-input-group__prepend {
          padding: 0;

          .el-image {
            display: flex;
            justify-content: center;

            img {
              height: 38px;
              width: 81px;
            }
          }
        }
      }
    }

    .phoneCaptchaLoginForm {
      .rememberBody {
        display: flex;
        justify-content: space-between;
      }

      .imgCaptcha {
        .el-input-group__append, .el-input-group__prepend {
          padding: 0;

          .el-image {
            display: flex;
            justify-content: center;

            img {
              height: 38px;
              width: 81px;
            }
          }
        }
      }
    }

    .loginButton {
      padding: 12px 44.5%;
      background: #5575E4;
    }

    .register {
      display: flex;
      justify-content: flex-end;
    }
  }
}
.dfvb{
  width: 100%;
  height: 460px;
}
</style>